// Nav type
export type navLinkType = {
  label: string;
  url: string;
};

// Nav
const navLinks = [
  {
    label: 'Services',
    url: '#services',
  },
  {
    label: 'Projects',
    url: '#works',
  },
  {
    label: 'About',
    url: '#about-me-section',
  },
  {
    label: 'Testimonials',
    url: '#testimonials-section',
  },
  {
    label: 'Contact',
    url: '#contact-section',
  },
];
const navbarLinks = [
  {
    label: 'Home',
    url: '#app',
  },
  ...navLinks,
];

const socialLinks = [
  {
    label: 'X',
    url: 'https://x.com/srikarmaddena',
  },
  {
    label: 'GitHub',
    url: 'https://github.com/srikarmaddena',
  },
  {
    label: 'LinkedIn',
    url: 'https://www.linkedin.com/in/srikar-maddena-8b1169258/',
  },
];

const heroText =
  'A Software Engineer architecting and scaling robust full-stack systems and ML solutions.';

const locationPlace = `28°32'18.8"N 81°22'45.2"W`;
const locationCountry = 'United States';

// cal.com (placeholder — swap with your own link when ready)
const dataCalNamespace = '30min';
const dataCalLink = 'srikarmaddena/30min';
const dataCalConfig =
  '{"layout":"month_view", "theme": "dark", "brand": "#8C8C73"}';

export {
  socialLinks,
  heroText,
  locationPlace,
  locationCountry,
  navLinks,
  navbarLinks,
  dataCalNamespace,
  dataCalLink,
  dataCalConfig,
};
